import React, { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";

import { db } from "../../Firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";

function DailyURL() {
  const [commonData, setCommonData] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [editData, setEditData] = useState({ daily_task_url: "", daily_video_url: "" });

  useEffect(() => {
    const fetchCommonData = async () => {
      try {
        const snapshot = await getDocs(collection(db, "common_data"));
        const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setCommonData(data);
      } catch (error) {
        console.error("Error fetching common data: ", error);
      }
    };

    fetchCommonData();
  }, []);

  const handleView = (data) => {
    setSelectedData(data);
    setOpenView(true);
  };

  const handleEdit = (data) => {
    setSelectedData(data);
    setEditData({ daily_task_url: data.daily_task_url, daily_video_url: data.daily_video_url });
    setOpenEdit(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveEdit = async () => {
    try {
      const ref = doc(db, "common_data", selectedData.id);
      await updateDoc(ref, editData);
      setCommonData((prev) =>
        prev.map((item) => (item.id === selectedData.id ? { ...item, ...editData } : item))
      );
      setOpenEdit(false);
    } catch (error) {
      console.error("Error updating data: ", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Daily URL
                </MDTypography>
              </MDBox>

              <MDBox pt={3} pb={3} mx={2}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableBody>
                      {commonData.map((data) => (
                        <React.Fragment key={data.id}>
                          <TableRow style={{ backgroundColor: "#fafafa" }}>
                            <TableCell style={{ width: "35%" }}>
                              <strong>Daily Task URL</strong>
                              <br />
                              <br />
                              {data.daily_task_url}
                            </TableCell>
                            <TableCell style={{ width: "35%" }}>
                              <strong>Daily Video URL</strong>
                              <br />
                              <br />
                              {data.daily_video_url}
                            </TableCell>
                            <TableCell align="center" style={{ width: "30%" }}>
                              <strong>Actions</strong>
                              <br />
                              <br />
                              <IconButton onClick={() => handleView(data)} color="success">
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton onClick={() => handleEdit(data)} color="info">
                                <EditIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

      <Dialog open={openView} onClose={() => setOpenView(false)}>
        <DialogTitle>View Link Details</DialogTitle>
        <DialogContent>
          <p>
            <strong>Daily Task URL :</strong>
            <br />
            {selectedData?.daily_task_url}
          </p>
          <br />
          <p>
            <strong>Daily Video URL :</strong>
            <br />
            {selectedData?.daily_video_url}
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenView(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Link</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Daily Task URL"
            fullWidth
            name="daily_task_url"
            value={editData.daily_task_url}
            onChange={handleEditChange}
          />
          <TextField
            margin="dense"
            label="Daily Video URL"
            fullWidth
            name="daily_video_url"
            value={editData.daily_video_url}
            onChange={handleEditChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
          <Button
            onClick={handleSaveEdit}
            color="primary"
            variant="contained"
            style={{ color: "white" }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default DailyURL;
